import React from "react";
import { FormattedMessage } from "react-intl";
import { Title } from "@yoast/ui-library";

import * as styles from "./styles.module.scss";

interface MessageDescriptor {
	defaultMessage: string;
}

interface PageHeaderProps {
	title: MessageDescriptor;
	message?: MessageDescriptor;
	children?: React.ReactNode;
}

export const PageHeader = ( props: PageHeaderProps ) => {
	return (
		<div className={ styles.headerWrapper }>
			<Title>
				<FormattedMessage
					id="pageHeader.title"
					defaultMessage={ props.title.defaultMessage }
				/>
			</Title>
			{ props.message && <p>
				<FormattedMessage
					id="pageHeader.message"
					defaultMessage={ props.message.defaultMessage }
				/>
			</p> }
			{ props.children && <p>{ props.children }</p> }
		</div>
	);
};
